import Immutable, { List } from 'immutable';
import SessionSchedule from './SessionSchedule';

const GroupSummaryRecord = Immutable.Record({
  id: undefined,
  name: undefined,
  courseTypeName: undefined,
  code: undefined,
  status: undefined,
  mainTeacherName: undefined,
  coTeacherName: undefined,
  pa: undefined,
  teacherAssistant: undefined,
  sessionSchedules: new List(),
});

class GroupSummary extends GroupSummaryRecord { }

const reviver = ([key, seq]) => {
  if (! seq) return [key, seq];
  switch (key) {
    case 'sessionSchedules':
      return [key, new List(seq.map(SessionSchedule.create))];
    default:
      return [key, Immutable.fromJS(seq)];
  }
};

GroupSummary.create = (data) =>
  new GroupSummary(data).mapEntries(reviver);

export default GroupSummary;



// WEBPACK FOOTER //
// ./containers/Group/GroupSummary/model.js